/**
 * 车辆里程实体
 */

import { useState, useEffect } from 'react';
import {
    Modal,
    Row,
    Col,
    message,
    InputNumber,
} from 'antd';
import $ from 'jquery';
import { AddRequestHeaders, rff } from '../../incs/FunHelper';
import CNF from '../../incs/Config';

const MODULENAME = '车辆里程';

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [loading, setLoading] = useState(false);
    const [currentMileage, setCurrentMileage] = useState(1);

    const cancel = () => {
        props.updateMileage(false, null);
        setLoading(false);
    };

    useEffect(() => {
        if (props.record) {
            setCurrentMileage(props.record.current_mileage);
        }
    }, [props]);

    const ok = () => {
        //  参数校验
        if (currentMileage <= props.record.current_mileage || currentMileage - props.record.current_mileage > 10000) {
            messageApi.error('车牌里程录入错误！');
            return;
        }
        setLoading(true);
        $.ajax({
            url: `${CNF.api}cars/${props.record.key}/mileage`,
            headers: AddRequestHeaders(),
            type: 'PATCH',
            dataType: 'JSON',
            data: JSON.stringify({
                'add_mileage': currentMileage - props.record.current_mileage,
                'current_mileage': currentMileage,
            }),
        }).done(function (data) {
            if (data.res === 0) {
                messageApi.success(data.msg, CNF.messageDuration);
                setTimeout(function () {
                    cancel();
                    props.isRefresh();
                }, CNF.messageDuration * 1000);
            } else {
                setLoading(false);
                messageApi.error(data.msg, CNF.messageDuration);
            }
        }).fail(function (data) {
            setLoading(false);
            messageApi.error(data.responseJSON.detail, CNF.messageDuration);
        });
    };

    return (
        <>
            {contextHolder}
            <Modal
                width={350}
                title={'修改' + MODULENAME}
                open={props.open}
                onOk={ok}
                onCancel={cancel}
                keyboard={true}
                okText='确认'
                cancelText='取消'
                okButtonProps={{ disabled: loading }}
            >
                <Row>
                    <Col span={24}>{rff}当前里程</Col>
                    <Col span={24}>
                        <InputNumber
                            suffix='km'
                            min={props.record?.current_mileage}
                            step={1}
                            style={{ width: '100%' }}
                            value={currentMileage}
                            onChange={(value) => setCurrentMileage(value)}
                            disabled={loading}
                        />
                    </Col>
                </Row>
            </Modal>
        </>
    );
}

export default Entity